import React from 'react'
import PropTypes from 'prop-types'

import OpenInNewIcon from '@mui/icons-material/OpenInNew'

import { IconButton } from './Button'

function OpenInNewTabButton({ label = '', onClick = () => {}, disabled = false }) {
  return (
    <IconButton disabled={disabled} onClick={onClick} aria-label={label}>
      <OpenInNewIcon />
    </IconButton>
  )
}

OpenInNewTabButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
}

export default OpenInNewTabButton
